export default __webpack_public_path__ + "static/media/factor_left_bg.e405e6a0.png";